import React, { useState, useEffect } from "react";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import InfoIcon from "@mui/icons-material/Info";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import {
  Autocomplete,
  Modal,
  Select,
  useMediaQuery,
} from "@mui/material";
import { FormControlLabel } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import PreviewIcon from "@mui/icons-material/Preview";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DownloadIcon from '@mui/icons-material/Download';
import HelpIcon from "@mui/icons-material/Help";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { BASE_URL, DISABLED_MODULE } from "./../../global";
import { Grid, TextField, Toolbar } from "@mui/material";
import moment from "moment";
import Tooltip from "@mui/material/Tooltip";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import SendIcon from '@mui/icons-material/Send';
import { dataSheetListGuide } from "./guide";
import { paginationrowsPerPageOptions } from "../../constants/commonConst";
import axiosWithToken from "../../utils/components/axiosTokenConfig";
import ErrorModal from "../../utils/components/errorModal";
import { checkDSStatusByCount } from "../srf/countTester";
import InfoModal from "./infoModal";
import ListWrap from "../commonComponent/listWrap";
import MultipleJobAssignButton from "./editDatasheet/mulipleJobAssign";
import { certificateStatusUpdate, datasheetsApprove, datashettAprroveWithdrawl } from "./editDatasheet/submitHandlers";

// datatablse packages
var $ = require("jquery");
$.DataTable = require("datatables.net");

export default function DatasheetList(props) {
  const [page, setPage] = React.useState(() => Number(sessionStorage.getItem("ListPageCount") || 0));
  const [rowsPerPage, setRowsPerPage] = React.useState(() => Number(sessionStorage.getItem("ListRowsPerPage") || 30));
  const DataSheetListGuides = dataSheetListGuide();
  const urlPath = useLocation();
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width: 600px)");
  const [totalRows, setTotalRows] = React.useState(0);
  const [datasheet, setDatasheet] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState(sessionStorage.getItem("groupeSelectedFilters") || "");
  const [companyName, setCompanyName] = useState("");
  const [enableDisable, setEnableData] = React.useState("");
  const [usersArray, setUsersArray] = React.useState([]);
  const [allUsers, setUsers] = React.useState([]);
  const [finalData, setFinalData] = React.useState([]);
  const [searchBy, setSearchBy] = React.useState(
    sessionStorage.getItem("searchBy") || "DUC ID",
  );
  const [searchKey, setSearchKey] = React.useState(
    sessionStorage.getItem("searchKey") || "",
  );
  const [userType, setUserType] = React.useState(localStorage.getItem("type"));
  const [editAccess, setEditAccess] = React.useState(
    localStorage.getItem("editAccess")?.split(",").map(Number),
  );
  const [userId, setUserId] = React.useState(localStorage.getItem("id"));
  const [branch, setBranch] = React.useState(localStorage.getItem("branch"));
  const _clientId = localStorage.getItem("clientId");

  const validCompanies = localStorage.getItem("validClients");
  const [filterModalOpen, setFilterModalOpen] = React.useState(false);
  const [errormodalIsOpen, setErrorModalIsOpen] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState(null);
  const [dBStatus, setDBStatus] = React.useState("");
  const [settingList, setSettingList] = React.useState({});
  const [searched, setSearched] = React.useState(false);
  const [multipleJobAssign, setMultipleJobAssign] = useState(false);
  const [selectedSRFMultiple, setselectedSRfMultiple] = useState(null);
  const [selectedDisciplineIds, setSelectedDisciplineIds] = useState([]);
  const [selectedCalStatus, setselectedCalStatus] = useState("");
  const [multipleSRF, setmultipleSRF] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [jobAssignSelectedRows, setJobAssignSelectedRows] = useState([]);

  const disciplineID = localStorage.getItem("disciplineID");
  const queryParams = new URLSearchParams(urlPath.search);
  const filter = queryParams.get("filter");

  const [isModalInfoOpen, setIsModalInfoOpen] = React.useState(false);
  const [infoModalData, setInfoModalData] = React.useState(null);
  const handleInfoOpenModal = React.useCallback((data) => {
    setInfoModalData(data);
    setIsModalInfoOpen(true);
  }, []);
  const handleInfoCloseModal = React.useCallback(() => {
    setIsModalInfoOpen(false);
    setInfoModalData(null);
  }, []);

  const openErrorModal = (errorMessage, stackTrace, fileName) => {
    setErrorMessage({ errorMessage, stackTrace, fileName });
    setErrorModalIsOpen(true);
  };
  const closeErrorModal = () => {
    setErrorModalIsOpen(false);
  };

  const handleFilterOpen = () => setFilterModalOpen(true);
  const handleFilterClose = () => setFilterModalOpen(false);

  const columns = (() => {
    let columnName = [];

    columnName = columnName.concat([
      {
        id: "id",
        label: "Sr.No.",
        align: "left",
        minWidth: 40,
      },
      {
        id: "customerName",
        label: "Client",
        align: "left",
        minWidth: 40,
      },
      {
        id: "serviceReqNumber",
        label: "Service Request Number",
        align: "left",
        minWidth: 40,
      },
      {
        id: "jobNumber",
        label: "Job Number",
        align: "left",
        minWidth: 40,
      },
      {
        id: "certCertificateNumber",
        label: "Certificate Number",
        align: "left",
        minWidth: 40,
      },
      {
        id: "ULRNo",
        label: "ULR No",
        align: "left",
        minWidth: 40,
      },
      {
        id: "instrumentName",
        label: "Instrument Name",
        align: "left",
        minWidth: 40,
      },
      {
        id: "locationOfInstrument",
        label: "DUC Location",
        align: "left",
        minWidth: 40,
      },
      {
        id: "range",
        label: "Range",
        align: "left",
        minWidth: 40,
      },
      {
        id: "lc",
        label: "LC",
        align: "left",
        minWidth: 40,
      },
      {
        id: "DUCID",
        label: "DUC ID",
        align: "left",
        minWidth: 40,
      },
      {
        id: "serialNumber",
        label: "Serial Number",
        minWidth: 40,
        align: "left",
      },
      {
        id: "dateOfCalibration",
        label: "Date of Calibration",
        minWidth: 40,
        align: "left",
      },
      {
        id: "nextDueDate",
        label: "Due Date",
        minWidth: 40,
        align: "left",
      },
    ]);

    if (userType != "3") {
      columnName.push({
        id: "assignStatus",
        label: "Assign To",
        minWidth: 40,
        align: "left",
      });
    }

    return columnName;
  })();

  const updateEnableDisable = (value, id) => {
    const newColumnName = [...enableDisable];
    newColumnName[id] = id + "," + value;
    setEnableData(newColumnName);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    sessionStorage.setItem("currentPath", urlPath.pathname);
    sessionStorage.setItem("ListPageCount", newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    sessionStorage.setItem("ListRowsPerPage", event.target.value);
    sessionStorage.setItem("ListPageCount", 0);
  };

  const getQuery = (count) => {
    let whereConditions = "where ds.status = 1 ";
    let pagination_settings = "";
    // Handle multiple filter selections
    const statusFilterMap = {
      Uncalibrated: `(totalReadings IS NULL OR totalReadings = 0)`,
      Calibrated: `(totalReadings IS NOT NULL AND totalReadings > 0)`
    };

    if (selectedFilters && statusFilterMap[selectedFilters]) {
      whereConditions += ` and ${statusFilterMap[selectedFilters]} `;
    }
    if (searchBy !== "" && searchKey != "") {
      let colName = {
        "Inst. Name": "ins.instrumentName",
        "Client": "cust.companyName",
        "DUC ID": "ds.DUCID",
        "Certificate Number": "cert.certificateNumber",
        "SRF Number": "ds.serviceReqNumber",
        "Job Number": "ds.jobNumber",
        "DUC Location": "ds.locationOfInstrument",
        "ULR No": "cert.ULRNo",
        "Serial Number": "ds.serialNumber",
      }[searchBy];
      whereConditions += `and LOWER(${colName}) like LOWER('%${searchKey}%') `;
    }

    if (props.isCount == true) {
      whereConditions +=
        whereConditions.length > 0
          ? `and (ds.assignedUser=${userId} and ds.calibratedby is null) `
          : `where (ds.assignedUser=${userId} and ds.calibratedby is null) `;
    }

    if(userType == 2) {
      if (filter === "self") {
        whereConditions += ` and ds.createdby = ${userId} `;
      } else if (filter === "assigned") {
        whereConditions += ` and ds.assignedUser = ${userId} `;
      } else if (filter === "pending") {
        whereConditions += ` and (ds.totalReadings IS NULL OR ds.totalReadings = 0) and (ds.createdby = ${userId} OR ds.assignedUser = ${userId}) `;
      } else if (filter === "completed") {
        whereConditions += ` and (ds.totalReadings IS NOT NULL AND ds.totalReadings > 0) and (ds.createdby = ${userId} OR ds.assignedUser = ${userId}) `;
      }
    }

    if (
      (userType == "2" || userType == "8") &&
      props.rolesInfo?.currentRole?.id == 2 &&
      disciplineID != "null"
    ) {
      whereConditions +=
        whereConditions.length > 0
          ? ` and (disc.id IN (${disciplineID})) `
          : `where (disc.id IN (${disciplineID})) `;
    }

    if(settingList["hideSRF"]?.toLowerCase() === "true"){
      whereConditions +=
          whereConditions.length > 0
            ? ` AND (ds.hideSrfUserIds IS NULL OR FIND_IN_SET(${userId}, ds.hideSrfUserIds) = 0)`
            :  ` WHERE (ds.hideSrfUserIds IS NULL OR FIND_IN_SET(${userId}, ds.hideSrfUserIds) = 0)`;
  }

    if ((userType == "2" || userType == "8") && disciplineID == "null") {
      whereConditions +=
        whereConditions.length > 0
          ? `and (ds.assignedUser=${userId}`
          : `where (ds.assignedUser=${userId}`;
      whereConditions += ` or ds.createdby=${userId}`;
      // whereConditions +=
      //   validCompanies?.length > 0
      //     ? whereConditions.length > 0
      //       ? ` or cust.id in (${validCompanies}))`
      //       : ` where cust.id in (${validCompanies})`
      //     : ")";
       //site incharge show only user assign companies
      if (userType == "8" && validCompanies?.length > 0) {
        whereConditions += ` or cust.id in (${validCompanies}))`;
      } else {
        whereConditions += `)`;
      }
    }

    if (selectedDisciplineIds.length > 0) {
      whereConditions +=
        whereConditions.length > 0
          ? ` AND disc.id IN (${selectedDisciplineIds.join(",")}) `
          : ` WHERE disc.id IN (${selectedDisciplineIds.join(",")}) `;
    }

    if (selectedCalStatus === "CALIBRATED") {
      whereConditions +=
        whereConditions.length > 0
          ? ` AND totalReadings IS NOT NULL AND totalReadings > 0 AND calibratedBy IS NOT NULL `
          : ` WHERE totalReadings IS NOT NULL AND totalReadings > 0 AND calibratedBy IS NOT NULL `;
    } else if (selectedCalStatus === "NON_CALIBRATED") {
      whereConditions +=
        whereConditions.length > 0
          ? ` AND (totalReadings IS NULL OR totalReadings = 0 OR calibratedBy IS NULL) `
          : ` WHERE (totalReadings IS NULL OR totalReadings = 0 OR calibratedBy IS NULL) `;
    }

    if (userType == "3") {
      whereConditions +=
        whereConditions.length > 0
          ? ` and (ds.clientId=${_clientId}) and datasheetApprovedBy IS NOT NULL and datasheetApprovedBy != ''`
          : `where (ds.clientId=${_clientId}) and datasheetApprovedBy IS NOT NULL and datasheetApprovedBy != ''`;
    }


    whereConditions +=
      (userType == 4 || userType == 5) && branch && branch.length
        ? (whereConditions ? " and " : "") + ` cust.branch in (${branch})`
        : "";

    if (rowsPerPage != -1) {
      pagination_settings = `limit ${rowsPerPage} offset ${
        rowsPerPage * Number(page)
      }`;
    }

    let data = {
      query: `select disc.id as discID, cert.status AS certStatus, cert.certificateNumber AS certCertificateNumber, ds.calibrationCoordinates, ds.complianceStatus, cert.ULRNo AS ULRNo, ds.datasheetApprovedBy, ds.totalReadings, ds.calibrationType,ds.mpe, ds.locationOfInstrument, ds.createdby, ds.calFrequency, ds.lastModified, ds.calibratedBy, cust.companyName, cust.uniCode, ins.instrumentName,ins.id as insId,ds.id,ds.workOrderNumber,ds.certificateNumber,ds.calibrationDate,ds.calProcRefNo,ds.ranges,ds.lc,ds.DUCID,ds.identificationNo,ds.jobNumber,ds.nextDueDate,ds.dateOfIssue,ds.assignedUser,ds.serialNumber,ds.serviceReqNumber from datasheets as ds left join instruments as ins on ds.instrumentId = ins.id  left join clients as cust on ds.clientId = cust.id left join discipline as disc on disc.id = ins.disciplineId left join certificates AS cert ON ds.id = cert.id ${whereConditions} order by ds.id DESC ${pagination_settings}`,
    };
    if (count)
      data.query = `select count(1) as no_of_rows from datasheets as ds left join instruments as ins on ds.instrumentId = ins.id left join clients as cust on ds.clientId = cust.id left join discipline as disc on disc.id = ins.disciplineId left join certificates AS cert ON ds.id = cert.id ${whereConditions} order by ds.id DESC`;

    return data;
  };

  // api calls
  function getTotalRows() {
    let data = getQuery(true);
    axiosWithToken
      .post(BASE_URL + `dynamic`, data)
      .then(async (res) => {
        setTotalRows(res.data[0]?.no_of_rows);
      })
      .catch((err) => {
        console.error("datasheet data fetching error: ", err);
        if (err.message !== "request_aborted") {
          toast.error(
            <h6
              onClick={() =>
                openErrorModal(err.message, "getTotalRows", "Datasheet List")
              }
            >
              <u>Error: {err.message}</u>
            </h6>,
          );
        }
      });
  }

  function fetchDatasheet() {
    let data = getQuery();
    axiosWithToken
      .post(BASE_URL + `dynamic`, data)
      .then((res) => {
        setDatasheet([...res.data]);
        setFinalData([...res.data]);
      })
      .catch((err) => {
        console.error("datasheet data fetching error: ", err);
        if (err.message !== "request_aborted") {
          toast.error(
            <h6
              onClick={() =>
                openErrorModal(err.message, "fetchDatasheet", "Datasheet List")
              }
            >
              <u>Error: {err.message}</u>
            </h6>,
          );
        }
      });
  }

  var refresh = () => {
    window.location.reload(false);
    // <Link to="/master/master/standard">Home</Link>
  };
  const saveUserAndDsID = async (userId) => {
    if (!jobAssignSelectedRows.length) return;
    const assignedUserValue = userId === 0 ? null : userId;
    try {
      await axiosWithToken.post(`${BASE_URL}dynamic`, {
        query: `UPDATE datasheets SET assignedUser = ${assignedUserValue}, jobAssignedDate = NOW() WHERE id IN (${jobAssignSelectedRows.join(",")});`,
      });
      toast("Datasheets Assigned.");
      window.location.reload();
    } catch (err) {
      console.error("Error updating datasheets:", err);
    }
  };

  const getUserList = () => {
    let url = BASE_URL;
    axiosWithToken
      .get(url + "users")
      .then((res) => {
        setUsersArray(res.data);
      })
      .catch((err) => {
        if (err.message !== "request_aborted") {
          toast.error(
            <h6
              onClick={() =>
                openErrorModal(err.message, "getUserList", "Datasheet List")
              }
            >
              <u>Error: {err.message}</u>
            </h6>,
          );
        }
      });
  };
  const initializeuserData = () => {
    var pushCArray = [];
    for (let i = 0; i < usersArray.length; i++) {
      if (usersArray[i].type == 2 || usersArray[i].type == 8) {
        pushCArray.push({
          label: usersArray[i].id + ", " + usersArray[i].userName,
        });
      }
    }
    setUsers(pushCArray);
  };

  const storedSearchBy = sessionStorage.getItem("searched");
  useEffect(() => {
    if (storedSearchBy) {
      setSearched(true);
    }
  }, [storedSearchBy]);

  const search = () => {
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", urlPath.pathname);
    sessionStorage.setItem("ListPageCount", 0);
    sessionStorage.setItem("groupeSelectedFilters", selectedFilters);
    setPage(0);
    setSearched(true);
    fetchDatasheet();
    getTotalRows();
  };
  const clearSearch = () => {
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched", searched);
    sessionStorage.removeItem("currentPath");
    sessionStorage.removeItem("ListPageCount");
    sessionStorage.removeItem("ListRowsPerPage");
    sessionStorage.removeItem("groupeSelectedFilters");
    setPage(0);
    setSearchBy("DUC ID");
    setSelectedFilters("");
    setSearchKey("");
    setSelectedDisciplineIds([]);
    setselectedCalStatus("");
    setselectedSRfMultiple(null);
    setSearched(false);
    navigate("/datasheet");
  };

  function fetchSettings() {
    axiosWithToken
      .get(BASE_URL + `settings?_where=(status,eq,1)`)
      .then((res) => {
        let settings = res.data;
        let _settingList = {};
        settings.forEach((setting) => {
          _settingList[setting.keyName] = setting.value;
        });
        setSettingList(_settingList);
      })
      .catch((err) => {
        console.error("Error fetching setting:", err);
        if (err.message !== "request_aborted") {
          toast.error(
            <h6
              onClick={() =>
                openErrorModal(err.message, "fetchSettings", "datasheet List")
              }
            >
              <u>Error: {err.message}</u>
            </h6>,
          );
        }
      });
  }

  useEffect(() => {
    getUserList();
    checkDSStatusByCount(setDBStatus);
    fetchSettings();
  }, []);

  useEffect(() => {
    initializeuserData();
  }, [usersArray]);

  useEffect(() => {
    fetchDatasheet();
    getTotalRows();
  }, [rowsPerPage, page, disciplineID , settingList["hideSRF"]]);

  useEffect(() => {
    if (searched == false) {
      fetchDatasheet();
      getTotalRows();
    }
    if (searched) {
      setPage(sessionStorage.getItem("ListPageCount") || 0);
    }
  }, [searched]);

  useEffect(() => {
    if (selectedSRFMultiple) {
      setSearchBy("SRF Number");
      setSearchKey(selectedSRFMultiple);
      setmultipleSRF(true);
    }
  }, [selectedSRFMultiple]);

  useEffect(() => {
    if (multipleSRF || selectedDisciplineIds || selectedCalStatus) {
      fetchDatasheet();
      getTotalRows();
      setmultipleSRF(false);
    }
  }, [multipleSRF, selectedSRFMultiple, selectedDisciplineIds, selectedCalStatus]);

  const TablePaginationActions = (props) => {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    );
  };

  const filterSection = () => (
    <div>
      <Grid
        container
        spacing={2}
        alignItems="center"
        style={{ padding: "5px 0px" }}
      >
        <Grid item xs={12} sm={6} md={2} lg={2.5}>
          <Autocomplete
            sx={{
              m: 0,
              width: "100%",
            }}
            className="Listinputcss"
            size="small"
            value={searchBy}
            id="datasheet_list_searchby"
            options={[
              { key: "customerName", label: "Client" },
              { key: "instrumentName", label: "Inst. Name" },
              { key: "duc", label: "DUC ID" },
              { key: "serialNumber", label: "Serial Number" },
              { key: "certificateNumber", label: "Certificate Number" },
              { key: "srfNumber", label: "SRF Number" },
              { key: "jobNumber", label: "Job Number" },
              { key: "locationOfInstrument", label: "DUC Location" },
              { key: "ULRNo", label: "ULR No" },
            ]}
            isOptionEqualToValue={(option, value) => option.label === value}
            renderInput={(params) => (
              <TextField {...params} label="Search By" />
            )}
            onInputChange={(event, newInputValue) => {
              if (newInputValue === "") setSearchKey("");
              setSearchBy(newInputValue);
              setSearched(false);
            }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={2}
          lg={2.5}
          id="datasheet_list_searchbytext"
        >
          <TextField
            className="Listinputcss"
            style={{ width: "100%" }}
            label={"Enter " + searchBy}
            size="small"
            variant="outlined"
            inputProps={{
              autoComplete: "off",
            }}
            value={searchKey}
            onChange={(e) => {
              setSearchKey(e.target.value);
              setSearched(false);
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3} lg={3}>
          <Autocomplete
            sx={{
              m: 0,
              width: "100%",
            }}
            className="Listinputcss"
            size="small"
            value={selectedFilters}
            id="datasheet_list_statusfilter"
            options={["Uncalibrated", "Calibrated"]}
            renderInput={(params) => (
              <TextField {...params} label="Filter by Status" />
            )}
            onChange={(event, newValue) => {
              setSelectedFilters(newValue);
              setSearched(false);
            }}
          />
        </Grid>
        <Grid
          item
          xs={6}
          sm={6}
          md={1}
          lg={1}
          textAlign={"left"}
          id="datasheet_list_searchbtn"
        >
          <Button
            variant="contained"
            size="small"
            color={searched ? "error" : "primary"}
            onClick={() => {
              searched ? clearSearch() : search();
              handleFilterClose();
            }}
          >
            {searched ? <RestartAltIcon /> : <SearchIcon />}
          </Button>
        </Grid>
        {!isMobile && showCheckboxForJobAsiign && (
            <Grid item xs={6} sm={6} md={2} lg={1.5}>
              <Button
                variant="contained"
                size="small"
                onClick={() => {
                  setMultipleJobAssign(!multipleJobAssign);
                }}
              >
                Job Assign
              </Button>
            </Grid>
          )}
      </Grid>
      {selectedRows && selectedRows.length ? (
        <Grid
          container
          spacing={2}
          align="left"
          style={{ display: "flex" }}
          sx={{ mt: 1, mb: 1 }}
        >
          {props.rolesInfo?.currentRole?.id == 2 && (
            <Grid item xs={6} sm={3} md={2} lg={2}>
              <Button
                variant="contained"
                color="success"
                size="small"
                startIcon={<CheckCircleIcon />}
                onClick={async() => {
                  const selectedCertificates =
                    datasheet?.filter((ds) => selectedRows.includes(ds.id)) ||
                    [];
                  const noncomplianceStatusCerts = selectedCertificates?.filter(
                    (ds) => ds.complianceStatus != 1
                  );
                  const complianceStatusCerts =
                    selectedCertificates
                      ?.filter((ds) => ds.complianceStatus == 1)
                      ?.map((ds) => ds.id) || [];
                  const message =
                    noncomplianceStatusCerts.length > 0
                      ? `Compliance Status is failed for the following:\n${noncomplianceStatusCerts
                          .map(
                            (ds) =>
                              `Instrument Name: ${ds.instrumentName}, DUCID: ${ds.DUCID}, Job NO: ${ds.jobNumber}`
                          )
                          .join("\n")}`
                      : "";

                  // Concatenating compliantand non-compliant certificates' IDs
                  let allDatasheetToApprove = [
                    ...(noncomplianceStatusCerts?.map((ds) => ds.id) || []),
                    ...complianceStatusCerts,
                  ];

                  // show alert Compliance Status failed
                  if (
                    settingList["Compliance Status Alert"]?.toLowerCase() ===
                      "true" &&
                    noncomplianceStatusCerts.length > 0
                  ) {
                    window.alert(message);
                  }

                  if (
                    editAccess?.includes(7) &&
                    allDatasheetToApprove.length > 0
                  ) {
                   await datasheetsApprove(allDatasheetToApprove);
                  } else {
                    if (complianceStatusCerts?.length > 0) {
                     await datasheetsApprove(complianceStatusCerts);
                    }
                  }
                }}
              >
                Approve
              </Button>
            </Grid>
          )}
          <Grid item xs={6} sm={3} md={2} lg={2.5}>
            <Button
              variant="contained"
              size="small"
              onClick={()=>datashettAprroveWithdrawl(selectedRows)}
            >
              Withdraw Approval
            </Button>
            </Grid>
        </Grid>
      ) : null}
      {jobAssignSelectedRows && jobAssignSelectedRows.length ? (
        <Grid container spacing={2} align="left" style={{ display: "flex" }} sx={{ mt: 1, mb: 1 }}
        >          
          <Grid item xs={12} md={2}>
            <Autocomplete
              sx={{m: 0, width: "100%",}}
              className="Listinputcss"
              size="small"
              id="combo-box-demos"
              options={[
                { label: "0, Withdraw Job" }, //  not assigned anyone
                ...allUsers,
              ]}
              getOptionLabel={(option) => option.label}
              renderOption={(props, option) => (
                <li {...props}
                  style={{color: option.label.startsWith("0, Withdraw Job") ? "red" : "inherit", }}
                >
                  {option.label}
                </li>
              )}
              renderInput={(params) => (
                <TextField {...params} label="Job Assign" />
              )}
              onInputChange={(event, newInputValue) => {
                saveUserAndDsID(parseInt(newInputValue.split(",")[0]));
              }}
            />
          </Grid>
        </Grid>
      ) : null}
    </div>
  );
  const filterModal = () => {
    return (
      <Modal open={filterModalOpen} size="md">
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "calc(100% - 30%)",
            backgroundColor: "white",
            // border: "2px solid #000",
            boxShadow: 24,
            padding: "10px",
          }}
        >
          <Button
            variant="contained"
            size="small"
            color="error"
            style={{ float: "right" }}
            onClick={handleFilterClose}
          >
            X
          </Button>
          {filterSection()}
        </Box>
      </Modal>
    );
  };
 
  const handleSelectAllClick = (event) => {
    const allSelected =
      selectedRows.length ===
      datasheet?.filter((row) => row.calibratedBy !== null).length;

    if (!allSelected || selectedRows.length === 0) {
      const newSelectedRows = datasheet
        ?.filter((row) => row.calibratedBy !== null)
        ?.map((row) => row.id);
      setSelectedRows(newSelectedRows);
    } else {
      setSelectedRows([]);
    }
  };

  // Function to handle individual row selection
  const handleRowClick = (event, id) => {
    const selectedIndex = selectedRows.indexOf(id);
    let newSelectedRows = [];

    if (selectedIndex === -1) {
      newSelectedRows = newSelectedRows.concat(selectedRows, id);
    } else if (selectedIndex === 0) {
      newSelectedRows = newSelectedRows.concat(selectedRows.slice(1));
    } else if (selectedIndex === selectedRows.length - 1) {
      newSelectedRows = newSelectedRows.concat(selectedRows.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedRows = newSelectedRows.concat(
        selectedRows.slice(0, selectedIndex),
        selectedRows.slice(selectedIndex + 1)
      );
    }
    setSelectedRows(newSelectedRows);
  };
  
  const handleJobAssignSelectAll = () => {
    if (jobAssignSelectedRows.length === datasheet.length) {
      setJobAssignSelectedRows([]);
    } else {
      setJobAssignSelectedRows(datasheet.map(row => row.id));
    }
  };
  
  const handleJobAssignRowClick = (id) => {
    setJobAssignSelectedRows((prev) =>
      prev.includes(id)
        ? prev.filter(rowId => rowId !== id)
        : [...prev, id]
    );
  };

  let showCheckboxForApprove = props.rolesInfo?.currentRole?.id == 2 && userType !== "3" && !isMobile && disciplineID != "null";

  let showCheckboxForJobAsiign = (userType == 1 || userType == 4 || userType == 5 || userType == 8 || props.rolesInfo?.currentRole?.id == 2);      

  return (
    <ListWrap>
      {dBStatus === "sick" ? (
        <h1 style={{ color: "red" }}>
          {" "}
          Record count is mismatching.
          <br /> please contact the support team. Tel: +91 9769847865
        </h1>
      ) : null}
      {dBStatus !== "sick" && (
        <>
          {filterModal()}
          <div style={{ display: "flex", justifyContent: "flex-start" }}>
            <Button
              style={{ display: isMobile ? "block" : "none" }}
              onClick={handleFilterOpen}
            >
              <FilterAltIcon />
            </Button>
          </div>
          <div
            style={{
              position: "fixed",
              top: isMobile ? "6.6%" : "10%",
              right: isMobile ? "-1%" : "0%",
              zIndex: 99,
            }}
          >
            <Tooltip title="User Guide" placement="top-start">
              <Button
                onClick={() => {
                  DataSheetListGuides.drive();
                }}
              >
                <HelpIcon />
              </Button>
            </Tooltip>
          </div>
          {!isMobile && filterSection()}
          {multipleJobAssign && (
            <MultipleJobAssignButton
              multipleJobAssign={multipleJobAssign}
              setMultipleJobAssign={setMultipleJobAssign}
              allUsers={allUsers}
              setselectedSRfMultiple={setselectedSRfMultiple}
              setSearched={setSearched}
              clearSearch={clearSearch}
              setSelectedDisciplineIds={setSelectedDisciplineIds}
              setselectedCalStatus={setselectedCalStatus}
              selectedCalStatus={selectedCalStatus}
            />
          )}
          <Box sx={{ width: "100%", overflow: "hidden", display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
            <TableContainer sx={{ flex: 1, overflow: 'auto' }}>
              <Table
                stickyHeader
                aria-label="sticky table"
                className="table-responsive"
                size="small"
                id="datasheet_list_table"
                sx={{ borderCollapse: "collapse" }}
              >
                <TableHead>
                  <TableRow>
                    {showCheckboxForApprove && (
                      <TableCell style={{ padding: "5px" }}>
                        <b>Approve</b>
                        <Checkbox
                          indeterminate={
                            selectedRows.length > 0 &&
                            selectedRows.length < datasheet.length
                          }
                          checked={selectedRows.length === datasheet.length}
                          onChange={handleSelectAllClick}
                        />
                      </TableCell>
                    )}
                    {showCheckboxForJobAsiign && (
                      <TableCell sx={{ padding: "5px" }}>
                        <b>Job Assign</b>
                        <Checkbox
                          indeterminate={
                            jobAssignSelectedRows.length > 0 &&
                            jobAssignSelectedRows.length < datasheet.length
                          }
                          checked={jobAssignSelectedRows.length === datasheet.length}
                          onChange={handleJobAssignSelectAll}
                        />
                      </TableCell>
                    )}
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{
                          minWidth: column.minWidth,
                          padding: column.padding,
                        }}
                      >
                        <b>{column.label}</b>
                      </TableCell>
                    ))}
                    <TableCell>
                      <b>Actions</b>
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {finalData?.length > 0 ? (
                    finalData.map((row, index) => {
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={row.id}
                        >
                          {showCheckboxForApprove ? (
                            <TableCell
                              sx={{ padding: "5px", textAlign: "center" }}
                            >
                              <FormControlLabel
                                classes={{
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                                sx={{
                                  gap: 2,
                                  margin: 0,
                                }}
                                control={
                                  <Checkbox
                                    id="certificate-certificatelistselectcheckbox"
                                    checked={
                                      selectedRows.indexOf(row.id) !== -1
                                    }
                                    onChange={(event) =>
                                      handleRowClick(event, row.id)
                                    }
                                  />
                                }
                                disabled={row.calibratedBy == null}
                              />
                            </TableCell>
                          ) : null}
                          {showCheckboxForJobAsiign && (
                          <TableCell sx={{ padding: "5px", textAlign: "center" }}>
                            <Checkbox
                              checked={jobAssignSelectedRows.includes(row.id)}
                              onChange={() => handleJobAssignRowClick(row.id)}
                            />
                          </TableCell>
                        )}
                          <TableCell>
                            {rowsPerPage * Number(page) + index + 1}
                          </TableCell>
                          <TableCell
                            title={
                              row.calibrationType == 1
                                ? "NABL"
                                : row.calibrationType == 2
                                  ? "IAS"
                                  : "NONANBL"
                            }
                          >
                            {row.companyName} <b>{row.uniCode ? `(${row.uniCode})` : ''}</b>
                          </TableCell>
                          <TableCell
                            style={{
                              backgroundColor:
                               row.datasheetApprovedBy != null
                                ? "#7B7BDF"
                                : row?.totalReadings && row?.totalReadings != 0
                                  ? "#22c9b0"
                                  : "transparent",
                            }}
                            title={
                              row.datasheetApprovedBy != null
                              ? `Approved by ${
                                  usersArray?.find((user) => user.id == row.datasheetApprovedBy)
                                    ?.userName || ""
                                }`
                              : row?.totalReadings != 0
                                ? `Calibratedby By ${
                                    usersArray?.find(
                                      (user) => user.id == row.calibratedBy,
                                    )?.userName || ""
                                  }`
                                : ""
                            }
                          >
                            <Link
                              to={`/datasheet/edit/${row.id}/${row.insId}`}
                              className="custom-link"
                              title="Edit Datasheet"
                              style={{pointerEvents: userType == 3 ? 'none' : 'auto',}}
                            >
                              {row.serviceReqNumber}
                            </Link>
                          </TableCell>
                          <TableCell
                            style={{
                              backgroundColor:
                               row.datasheetApprovedBy != null
                                ? "#7B7BDF"
                                : row?.totalReadings && row?.totalReadings != 0
                                  ? "#22c9b0"
                                  : "transparent",
                            }}
                            title={
                              row.datasheetApprovedBy != null
                              ? `Approved by ${
                                  usersArray?.find((user) => user.id == row.datasheetApprovedBy)
                                    ?.userName || ""
                                }`
                              : row?.totalReadings != 0
                                ? `Calibratedby By ${
                                    usersArray?.find(
                                      (user) => user.id == row.calibratedBy,
                                    )?.userName || ""
                                  }`
                                : ""
                            }
                          >
                            <Link
                              to={`/datasheet/edit/${row.id}/${row.insId}`}
                              className="custom-link"
                              title="Edit Datasheet"
                              style={{pointerEvents: userType == 3 ? 'none' : 'auto',}}
                            >
                              {row.jobNumber}
                            </Link>
                          </TableCell>
                          <TableCell>{row.certCertificateNumber}</TableCell>
                          <TableCell>{row.ULRNo}</TableCell>
                          <TableCell>{row.instrumentName}</TableCell>
                          <TableCell>{row?.locationOfInstrument}</TableCell>
                          <TableCell>
                            {row.ranges
                              ?.replaceAll("||", ", ")
                              ?.replaceAll("|", " to ")
                              ?.replaceAll("#", "")}
                          </TableCell>
                          <TableCell>
                            {row.lc
                              ?.replaceAll("||", ", ")
                              ?.replaceAll("|", " to ")
                              ?.replaceAll("#", "")}
                          </TableCell>
                          <TableCell>{row.DUCID}</TableCell>
                          <TableCell>{row.serialNumber}</TableCell>
                          <TableCell style={{ textWrap: "nowrap" }}>
                            {row.calibrationDate
                              ? moment(row.calibrationDate).format("DD-MM-YYYY")
                              : ""}
                          </TableCell>
                          <TableCell style={{ textWrap: "nowrap" }}>
                            {row?.calFrequency == "Not Required"
                              ? "-"
                              : row?.calFrequency == "Customer Defined"
                              ? "Customer Defined"
                              : row?.calFrequency == "NA"
                              ? "NA"
                              : row?.nextDueDate
                              ? moment(row.nextDueDate).format("DD-MM-YYYY")
                              : ""}
                          </TableCell>
                          {userType != "3" && (
                            <TableCell>
                              {row.assignedUser !== null
                                ? allUsers
                                    ?.find((user) => {
                                      const id = parseInt(
                                        user.label?.split(",")[0]?.trim(),
                                      );
                                      return id === row.assignedUser;
                                    })
                                    ?.label?.split(",")[1]
                                    ?.trim() || ""
                                : ""}
                            </TableCell>
                          )}
                          <TableCell>
                            <ButtonGroup
                              size="small"
                              aria-label="small button group"
                            >
                              {userType !== "3" && (
                                <Tooltip
                                  title={"Edit Datasheet"}
                                  placement="top-start"
                                >
                                <span>
                                  <Button
                                    id="datasheet_list_editbutton"
                                    component={Link}
                                    to={`/datasheet/edit/${row.id}/${row.insId}`}
                                  >
                                    <PreviewIcon />
                                  </Button>
                                </span>
                                </Tooltip>
                              )}
                              <Tooltip
                                title="Download Datasheet"
                                placement="top-start"
                              >
                                <Button
                                  id="datasheet_list_print"
                                  component={Link}
                                  to={`/datasheet/edit/${row.id}/${row.insId}/print`}
                                >
                                  <DownloadIcon />
                                </Button>
                              </Tooltip>
                              {userType != 3 && (
                             <Tooltip
                                title="Send for Approval"
                                placement="top-start"
                              >
                               <Button
                               disabled={row.certStatus == 3} size="small" onClick={()=>certificateStatusUpdate(row.id, row)}>
                               <SendIcon/>
                                </Button>
                              </Tooltip>
                              )}
                              {!DISABLED_MODULE?.includes("locationTracking") && (
                                <Tooltip
                                  title="info Datasheet"
                                  placement="top-start"
                                >
                                  <Button
                                    id="datasheet_list_history"
                                    onClick={() => handleInfoOpenModal(row)}
                                  >
                                    <InfoIcon />
                                  </Button>
                                </Tooltip>
                              )}
                            </ButtonGroup>
                          </TableCell>
                        </TableRow>
                      );
                    })
                  ) : (
                    <TableRow>
                      <TableCell colSpan={columns.length + 1} align="center">
                        <h6>
                          <b>Data Not Found</b>
                        </h6>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={paginationrowsPerPageOptions}
              count={totalRows}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              component="div"
              colSpan={3}
              SelectProps={{
                inputProps: {
                  "aria-label": "rows per page",
                },
                native: true,
              }}
              ActionsComponent={TablePaginationActions}
            />
            <ToastContainer />
            {errormodalIsOpen && (
              <ErrorModal
                errormodalIsOpen={errormodalIsOpen}
                closeErrorModal={closeErrorModal}
                errorMessage={errorMessage}
              />
            )}
            {isModalInfoOpen && (
              <InfoModal
                open={isModalInfoOpen}
                handleClose={handleInfoCloseModal}
                info={infoModalData}
                allUsers={usersArray}
              />
            )}
          </Box>
        </>
      )}
    </ListWrap>
  );
}
